import React from 'react';
import { CookieConsent as BaseCookieConsent } from 'react-cookie-consent';

import { Button, ButtonIntent, ButtonProps } from 'app/design-system/components/Button';
import { useTranslation } from 'app/lang';

import dictionary from './CookieConsent.dictionary.json';

import styles from './CookieConsent.module.scss';

export const CookieConsent = () => {
  const { t } = useTranslation();

  return (
    <BaseCookieConsent
      containerClasses={styles.root}
      buttonClasses={styles.button}
      buttonWrapperClasses={styles.buttonWrapper}
      disableStyles
      location="none"
      ButtonComponent={(props: ButtonProps) => (
        <Button
          {...props}
          intent={ButtonIntent.CALL_TO_ACTION}>
          {t(dictionary.buttonText)}
        </Button>
      )}>
      <p className={styles.text}>
        {t(dictionary.modalText)}
      </p>
    </BaseCookieConsent>
  );
};
